import { RouteType } from "../../../types/RouteType";

const qcInspectionRoute: RouteType = {
  name: "QC Inspection",
  path: "/qc/inspection/:productId/:stage",
  defaultParams: {
    productId: null,
    stage: "pre_pour",
  },
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./QCInspection.Header"),
      title: "QC Inspection",
      color: "primary",
      enableBackButton: true,
    },
    body: {
      component: () => import("./QCInspection.Body"),
      grayBackground: true,
    },
  },
  group: "Quality Control",
  requiresAuth: true,
  requiresPermission: false, // TODO: Add 'qc:inspector' permission check

  beforeEnter: async ({ rootStore, params }) => {
    try {
      const store = rootStore.qcInspectionStore;
      if (
        store &&
        typeof store === "object" &&
        "setStage" in store &&
        "loadProduct" in store
      ) {
        const productId = params.productId as string; // UUID string
        const stage = params.stage as "pre_pour" | "post_pour";

        (store as any).setStage(stage);
        await (store as any).loadProduct(productId);
      }
      return true;
    } catch (error) {
      console.error("Failed to load QC Inspection:", error);
      return false;
    }
  },

  onParamsChange: async ({ rootStore, params, previousParams }) => {
    if (
      params.productId !== previousParams?.productId ||
      params.stage !== previousParams?.stage
    ) {
      const store = rootStore.qcInspectionStore;
      if (
        store &&
        typeof store === "object" &&
        "setStage" in store &&
        "loadProduct" in store
      ) {
        const productId = params.productId as string;
        const stage = params.stage as "pre_pour" | "post_pour";

        (store as any).setStage(stage);
        await (store as any).loadProduct(productId);
      }
    }
  },

  onExit: ({ rootStore }) => {
    const store = rootStore.qcInspectionStore;
    if (store && typeof store === "object" && "reset" in store) {
      (store as any).reset();
    }
  },

  dialogs: [],
};

export default qcInspectionRoute;
